import { render } from "./ProposalVotes.vue?vue&type=template&id=fdd648c2"
import script from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalVotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdd648c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdd648c2', __exports__)) {
    api.reload('fdd648c2', __exports__)
  }
  
  module.hot.accept("./ProposalVotes.vue?vue&type=template&id=fdd648c2", () => {
    api.rerender('fdd648c2', render)
  })

}


export default __exports__